var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.statusOptions},on:{"change":_vm.handleStatusChange},model:{value:(_vm.member.pipelineStatus),callback:function ($$v) {_vm.$set(_vm.member, "pipelineStatus", $$v)},expression:"member.pipelineStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }